import { createSlice } from '@reduxjs/toolkit';
import { CourseActiveTabs } from "../types/enums/CourseActiveTabs";
import { checkForDuplicateTests } from '../components/coursePlan/addTestDialog/helpers/checkAddedTest'
import { checkIfTestInThisPhase, checkIfMainTestInThisWeek, processBulkDragPayload }  from '../helpers/helpers';
import _ from 'lodash';
const initialEditData = {
    phaseName: '',
    startDate: '',
    endDate: '',
    isRevision: false,
};

const initialState = {
    packageByIdData: {},
    packages: {},
    treeData: {},
    preFilters: {},
    selectedCourseData: [],
    bulkDrag: {},
    editData: { ...initialEditData },
    viewPlanData: {},
    filterSelectedQuestion: [],
    totalGoalsForComboCourse: [],
    scheduledTestData: [],
    packageData: {},
    mergedComboCourse: {},
    activeTab: '',
    coursePlanMandatoryFlag: false,
    basicInfoMandatoryFlag: false,
    advancedSettingMandatoryFlag: false,
    generalSettingsMandatoryFlag: false,
    seoMandatoryFlag: false,
    advancedSettingsDone: false,
    basicInfoDone: false,
    coursePlanDone: false,
    isCoursePublished: false,
    activeTabForCoursePlanLandingPage: 0,
    selectedGoalsForTestSeries: [],
    basicInfoValid: true,
    basicInfoUntouched: true,
    advancedSettingsValid: false,
    advancedSettingsUntouched: true,
    coursePlanValid: false,
    isTabOpen: false,
    tabVisited: {
        generalSettings: true,
        faq: false,
        seo: false
    },
    publishBtnClicked: false,
    isTestInAnyPhase: [],
    isCoursPlanTabAbleToPublish: false,
    includesScheduledTests: false,
    contentPreferences:{},
    scheduleTestUploadFlag: '',
    coursePackageList: [],
    revisedHours: {},
    phaseUploadUrl: {},
    activeCoursePlanViewList: []
};

const zero24 = '000000000000000000000000'




const contentManagementSlice = createSlice({
    name: 'contentManagementCreate',
    initialState: JSON.parse(JSON.stringify(initialState)),
    reducers: {
        setPackageByIdData: (state = {}, action = {}) => {
            const { payload = {}} = action;
            state.packageByIdData.packageData = payload;
        },
        setPackageById: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, ...payload };
        },
        resetPackageById: (state = {}, action = {}) => {
            const { packageByIdData = {} } = initialState;
            return { ...state, packageByIdData };
        },
        setPackages: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, ...payload };
        },
        resetPackages: (state = {}, action = {}) => {
            const { packages = [] } = initialState;
            return { ...state, packages };
        },
        setTreeData: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, ...payload };
        },
        setIncludesScheduledTests: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, includesScheduledTests: payload };
        },
        setPreFilters: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, preFilters: JSON.parse(JSON.stringify(payload.preFilters)) };
        },
        setSelectedCourseData: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, ...payload };
        },
        setBulkDrag: (state = {}, action = {}) => {
            const { payload = {} } = action;
            const updatedBulkDrag = processBulkDragPayload(state.treeData, payload);
            return { ...state, ...updatedBulkDrag };
        },
        setCoursePlanValid: (state = {}, action = {}) => {
            state.coursePlanValid = action.payload;
        },
        setTabVisited: (state = {}, action = {}) => {
            switch (action.payload) {
                case 'generalSettings': state.tabVisited.generalSettings = true; break;
                case 'faq': state.tabVisited.faq = true; break;
                case 'seo': state.tabVisited.seo = true; break;
                default:
            }
        },
        setEditData: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, ...payload };
        },
        setViewPlanData: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, ...payload };
        },
        setCoursePlanDone: (state = {}, action = {}) => {
            state.coursePlanDone = true;
        },
        setBasicInfoValid: (state = {}, action = {}) => {
            state.basicInfoValid = action.payload;
        },
        setBasicInfoMandatoryFlag: (state = {}, action = {}) => {
            state.basicInfoMandatoryFlag = action.payload;
        },
        setBasicInfoUntouched: (state = {}, action = {}) => {
            state.basicInfoUntouched = action.payload;
        },
        setAdvancedSettingsValid: (state = {}, action = {}) => {
            state.advancedSettingsValid = action.payload;
        },
        setAdvancedSettingsUntouched: (state = {}, action = {}) => {
            state.advancedSettingsUntouched = action.payload;
        },
        setAdvancedSettingMandatoryFlag: (state = {}, action = {}) => {
            state.advancedSettingMandatoryFlag = action.payload
        },
        setGeneralSettingsMandatoryFlag: (state = {}, action = {}) => {
            state.generalSettingsMandatoryFlag = action.payload;
            if (action.payload && state.seoMandatoryFlag) {
                state.advancedSettingMandatoryFlag = true;
            }
        },
        setSeoMandatoryFlag: (state = {}, action = {}) => {
            state.seoMandatoryFlag = action.payload;
            if (action.payload && state.generalSettingsMandatoryFlag) {
                state.advancedSettingMandatoryFlag = true;
            }
        },
        setActiveTab: (state = {}, action = {}) => {
            switch (action.payload) {
                case 0: state.activeTab = CourseActiveTabs.coursePlan; break;
                case 1: state.activeTab = CourseActiveTabs.basicInfo; break;
                case 2: state.activeTab = CourseActiveTabs.advancedSettings; break;
                default:
            }
        },
        setPublishBtnClicked: (state = {}, action = {}) => {
            state.publishBtnClicked = action.payload
        },
        setAdvancedSettingsDone: (state = {}, action = {}) => {
            state.advancedSettingsDone = true;
        },
        setBasicInfoDone: (state = {}, action = {}) => {
            state.basicInfoDone = true;
        },
        setFilterSelectedQuestion: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, ...payload };
        },
        addMilestoneTestInPhase: (state, action) => {
            const { payload: { phaseId, mileStoneTestData } } = action;
            let index = state.treeData.phases.findIndex(({ _id }) => _id === phaseId);
            if (index > -1) {
                const newPhase = { ...state.treeData.phases[index] };
                const newMilestoneTests = newPhase.milestoneTests.concat(mileStoneTestData);
                newPhase.milestoneTests = newMilestoneTests;
                state.treeData.phases[index] = newPhase;
            }
        },
        setTestSeries: (state, action) => {
            const testSeries = action.payload;

            state.treeData.testSeries = testSeries; // Check here
        },
        setTotalGoalsForComboCourse: (state = {}, action = {}) => {
            const { payload = [] } = action;
            return { ...state, totalGoalsForComboCourse: JSON.parse(JSON.stringify(payload)) };
        },
        setScheduledTestData: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, scheduledTestData: JSON.parse(JSON.stringify(payload.scheduledTests)) };
        },
        setScheduleTestUploadFlag: (state = {}, action = {}) => {
            state.scheduleTestUploadFlag = action.payload;
        },
        setBulkUploadTestData: (state, action) => {
            const { testData, testType } = action.payload;
            switch (testType) {
                case 'Upload Milestone Test':
                   let updatedPhases = [...state.treeData.phases];
                    testData.forEach((test) => {
                       const testStartDate = new Date(test.startDate);
                        const testEndDate = new Date(test.endDate);
                        const phasesLength = updatedPhases.length;
                        updatedPhases.forEach((phase, index) => {
                            let nextPhaseStartDate;
                            if(index !== phasesLength - 1) {
                                nextPhaseStartDate = updatedPhases[index + 1] && new Date(updatedPhases[index + 1].startDate)
                            } else {
                                nextPhaseStartDate = null;
                            }
                            const phaseStartDate = new Date(phase.startDate);
                            const phaseEndDate = new Date(phase.endDate);
                            const isTestInThisPhase = checkIfTestInThisPhase(
                                testStartDate,
                                testEndDate,
                                phaseStartDate,
                                phaseEndDate,
                                nextPhaseStartDate
                            );
                            if (isTestInThisPhase) {
                                let updatedMilestoneTests = [...updatedPhases[index].milestoneTests];
                                const { duplicateExists: testAlreadyExists} = checkForDuplicateTests(state.treeData.phases, [test]);
                                
                                
                                const updatedTestData = JSON.parse(JSON.stringify(test));
                               
                                updatedTestData['type'] = test.type || 'full';
                                updatedTestData['name'] = test.name;
                                updatedTestData['syllabus'] = test.syllabus;
                                updatedTestData['testId'] = test.testId || '000000000000000000000000';
                                updatedTestData['startDate'] = test.startDate;
                                updatedTestData['endDate'] = test.endDate;
                                updatedTestData['maxAttempts'] = test.maxAttempts;
                                updatedTestData['revisionTime'] = test.revisionTime;
                                updatedTestData['courseId'] = test.courseId;
                                if(+test.questionsCount > 0) {
                                    updatedTestData['questionsCount'] = test.questionsCount;
                                } else {
                                    updatedTestData['isQuestionsCountMissing'] = true;
                                }

                                if(!testAlreadyExists) {
                                    updatedMilestoneTests.push(updatedTestData);
                                    state.scheduleTestUploadFlag = 'Test Added'
                                } 
                              
                                updatedPhases[index].milestoneTests = updatedMilestoneTests;
                            }
                        });
                    });
                    state.treeData.phases = updatedPhases;
                    break;
                case 'Upload Main Test':
                    let phasesCopy = [..._.get(state,'treeData.phases',[])];
                    const { duplicateExists: overallDuplicateExists } = checkForDuplicateTests(state.treeData.phases, testData);
                    
                    
                    testData.forEach((test) => {
                        const testStartDate = new Date(test.startDate);
                        const testEndDate = new Date(test.endDate);
                        phasesCopy.forEach((phase, phaseIndex) => {
                            let updatedWeeks = [...phase.weeks];
                            let isTestAddedInAnyWeek = false;

                            const updatedTestData = JSON.parse(JSON.stringify(test));
                            updatedTestData['type'] = test.type || 'full';
                            updatedTestData['name'] = test.name;
                            // const copyOfSyllabus = {...test.paperDetail.syllabus};
                            updatedTestData['syllabus'] = test.syllabus;
                            updatedTestData['testId'] = test.testId || '000000000000000000000000';
                            
                            // updatedTestData['scheduleID'] = test.scheduleID;
                            // updatedTestData['status'] = test.status;
                            updatedTestData['startDate'] = test.startDate;
                            updatedTestData['endDate'] = test.endDate;
                            updatedTestData['maxAttempts'] = test.maxAttempts;
                            updatedTestData['revisionTime'] = test.revisionTime;
                            updatedTestData['courseId'] = test.courseId;
                            if(+test.questionsCount > 0) {
                                updatedTestData['questionsCount'] = test.questionsCount;
                            } else {
                                updatedTestData['isQuestionsCountMissing'] = true;
                            }
                        
                            const phasesLength = phasesCopy.length;
                            let nextPhaseStartDate;
                            if(phaseIndex !== phasesLength - 1) {
                                nextPhaseStartDate = phasesCopy[phaseIndex + 1] && new Date(phasesCopy[phaseIndex + 1].startDate)
                            } else {
                                nextPhaseStartDate = null;
                            }
                            const phaseStartDate = new Date(phase.startDate);
                            const phaseEndDate = new Date(phase.endDate);
                            const isTestInThisPhase = checkIfTestInThisPhase(
                                testStartDate,
                                testEndDate,
                                phaseStartDate,
                                phaseEndDate,
                                nextPhaseStartDate
                            );

                        if(isTestInThisPhase) {
                            updatedWeeks.forEach((week, weekIndex) => {
                                const weekStartDate = new Date(week.startDate);
                                const weekEndDate = new Date(week.endDate);
                                weekStartDate.setHours(0, 0, 0);
                                weekEndDate.setHours(23, 59, 59);
                                const isTestInThisWeek = checkIfMainTestInThisWeek(
                                    testStartDate,
                                    testEndDate,
                                    weekStartDate,
                                    weekEndDate
                                );
                              
                                if (isTestInThisWeek) {
                                    let updatedContent = [...updatedWeeks[weekIndex].content];
                                    const testAlreadyExists = test.testId !== zero24 &&  updatedContent.find((existingTest) => existingTest.testId === test.testId);
                                    
                                 
    

                                    if(!testAlreadyExists && !overallDuplicateExists) { 
                                        updatedContent.push(updatedTestData);
                                        state.scheduleTestUploadFlag = 'Test Added'
                                    } 
                                    // else {
                                    //     state.scheduleTestUploadFlag = 'Test already exists in the course'
                                    // }

                                    updatedWeeks[weekIndex].content = updatedContent;
                                    phasesCopy[phaseIndex].weeks = updatedWeeks;
                                    isTestAddedInAnyWeek = true;
                                }
                              
                            });
                            if(!isTestAddedInAnyWeek){
                                
                                let updatedExtraTests = [..._.get(phase,'extraTests',[])];
                                const isTestAlreadyInExtraTests = test.testId !== zero24 && updatedExtraTests.find((existingTest) => existingTest.testId === test.testId);
                                
                                if(!isTestAlreadyInExtraTests && !overallDuplicateExists){
                                    updatedExtraTests.push(updatedTestData)
                                    phasesCopy[phaseIndex].extraTests = updatedExtraTests;
                                }
                            }
                            }
                        });
                    });
                    state.treeData.phases = phasesCopy;
                    break;
                case 'Import Existing Tests':
                    let updatedPhasesCopy = [...state.treeData.phases];
                    testData.forEach((test) => {
                        const testStartDate = new Date(test.startDate);
                        const testEndDate = new Date(test.endDate);
                       
                        if(typeof testEndDate === 'object') {
                            // MileStone Test Flow
                            const phasesLength = updatedPhasesCopy.length;
                            updatedPhasesCopy.forEach((phase, index) => {
                                let nextPhaseStartDate;
                                if(index !== phasesLength - 1) {
                                    nextPhaseStartDate = updatedPhasesCopy[index + 1] && new Date(updatedPhasesCopy[index + 1].startDate)
                                } else {
                                    nextPhaseStartDate = null;
                                }
                                const phaseStartDate = new Date(phase.startDate);
                                const phaseEndDate = new Date(phase.endDate);
                                const isTestInThisPhase = checkIfTestInThisPhase(
                                    testStartDate,
                                    testEndDate,
                                    phaseStartDate,
                                    phaseEndDate,
                                    nextPhaseStartDate
                                );
                              
                                if (isTestInThisPhase) {
                                    let updatedMilestoneTests = [...updatedPhasesCopy[index].milestoneTests];
                                    const { duplicateExists: testAlreadyExists} = checkForDuplicateTests(state.treeData.phases, [test]);
                                   
                                    const updatedTestData = JSON.parse(JSON.stringify(test));
                                   
                                    updatedTestData['type'] = test.type || 'full';
                                    updatedTestData['name'] = test.name;
                                    updatedTestData['syllabus'] = test.syllabus;
                                    updatedTestData['testId'] = test.testId || '000000000000000000000000';

                                    updatedTestData['startDate'] = test.startDate;
                                    updatedTestData['endDate'] = test.endDate;
                                    updatedTestData['maxAttempts'] = test.maxAttempts;
                                    updatedTestData['revisionTime'] = test.revisionTime;
                                    updatedTestData['courseId'] = test.courseId;
                                    updatedTestData['questionsCount'] = test.questionsCount;
    
                                    if(!testAlreadyExists) {
                                        updatedMilestoneTests.push(updatedTestData);
                                        state.scheduleTestUploadFlag = 'Test Added'
                                    } 

    
                                    
                                    updatedPhasesCopy[index].milestoneTests = updatedMilestoneTests;
                                }
                            });
                        } else {
                            // Main Test Flow
                            const phasesLength = updatedPhasesCopy.length;
                            updatedPhasesCopy.forEach((phase, index) => {
                                let nextPhaseStartDate;
                                
                                if(index !== phasesLength - 1) {
                                    nextPhaseStartDate = updatedPhasesCopy[index + 1] && new Date(updatedPhasesCopy[index + 1].startDate)
                                } else {
                                    nextPhaseStartDate = null;
                                }
                                const phaseStartDate = new Date(phase.startDate);
                                const phaseEndDate = new Date(phase.endDate);
                               const isTestInThisPhase = checkIfTestInThisPhase(
                                    testStartDate,
                                    testEndDate,
                                    phaseStartDate,
                                    phaseEndDate,
                                    nextPhaseStartDate
                                );
                                if (isTestInThisPhase) {
                                    let isTestAddedInAnyWeek = false;
                                    if(phaseEndDate === undefined || phaseEndDate === null || phaseEndDate === ''){
                                        let updatedWeeks = [...phase.weeks];

                                        const updatedTestData = JSON.parse(JSON.stringify(test));
                                        updatedTestData['type'] = test.type || 'full';
                                        updatedTestData['name'] = test.name;
                                        updatedTestData['syllabus'] = test.syllabus;
                                        updatedTestData['testId'] = test.testId || '000000000000000000000000';
                                        updatedTestData['startDate'] = test.startDate;
                                        updatedTestData['endDate'] = test.endDate;
                                        updatedTestData['maxAttempts'] = test.maxAttempts;
                                        updatedTestData['revisionTime'] = test.revisionTime;
                                        updatedTestData['courseId'] = test.courseId;
                                        updatedTestData['questionsCount'] = test.questionsCount;

                                        updatedWeeks.forEach((week, weekIndex) => {
                                            const weekStartDate = new Date(week.startDate);
                                            const weekEndDate = new Date(week.endDate);
                                            weekStartDate.setHours(0, 0, 0);
                                            weekEndDate.setHours(23, 59, 59);
                                            const isTestInThisWeek = checkIfMainTestInThisWeek(
                                                testStartDate,
                                                testEndDate,
                                                weekStartDate,
                                                weekEndDate
                                            );

                                       

                                            if (isTestInThisWeek) {
                                                  let updatedContent = [...updatedWeeks[weekIndex].content];
                                                 const { duplicateExists : testAlreadyExists} = checkForDuplicateTests(state.treeData.phases, [test]);
                                                if(!testAlreadyExists) {
                                                    updatedContent.push(updatedTestData);
                                                    state.scheduleTestUploadFlag = 'Test Added'
                                                } 
                                                updatedWeeks[weekIndex].content = updatedContent;
                                                updatedPhasesCopy[index].weeks = updatedWeeks;
                                                isTestAddedInAnyWeek = true;
                                            }

                                        });

                                        if(!isTestAddedInAnyWeek){
                                            let updatedExtraTests = [...phase.extraTests];
                                            const isTestAlreadyInExtraTests = test.testId !== zero24 && updatedExtraTests.forEach((existingTest) => existingTest.testId === test.testId);
                                            if(!isTestAlreadyInExtraTests){
                                                updatedExtraTests.push(updatedTestData)
                                                updatedPhasesCopy[index].extraTests = updatedExtraTests;
                                            }
                                        }

                                    }
                                   let updatedIsTestInAnyPhase = [...state.isTestInAnyPhase]
                                    updatedIsTestInAnyPhase.push(true)
                                    state.isTestInAnyPhase = updatedIsTestInAnyPhase
                                } else {
                                    let updatedIsTestInAnyPhase = [...state.isTestInAnyPhase]
                                    updatedIsTestInAnyPhase.push(false)
                                    state.isTestInAnyPhase = updatedIsTestInAnyPhase
                                }
                            });
                        }
                    });
                    state.treeData.phases = updatedPhasesCopy;
                    break;
                default:
            }
        },
        updateMilestoneTest: (state, action) => {
            
            const { testData, phase: receivedPhaseData, isDelete = false, courseId, testIndex } = action.payload;
            const updatedTestData = JSON.parse(JSON.stringify(testData));
            if(!isDelete) {
                updatedTestData['type'] = testData.type || 'phase';
                updatedTestData['name'] = testData.paperDetail.name || testData.displayName;
                updatedTestData['contentId'] = testData.contentId
                const copyOfSyllabus = {...testData.paperDetail.syllabus};
                updatedTestData['syllabus'] = copyOfSyllabus.text;
                updatedTestData['testId'] = testData.testId || '000000000000000000000000'; // Changed from testData.paperDetail.id
                updatedTestData['mappedTestName'] = testData.mappedTestName;
                updatedTestData['scheduleID'] = testData.scheduleID;
                updatedTestData['status'] = testData.status;
                updatedTestData['startDate'] = testData.scheduleDate;
                updatedTestData['endDate'] = testData.scheduleEndDate;
                updatedTestData['maxAttempts'] = testData.maxAttempt;
                updatedTestData['revisionTime'] = testData.blockRevisionTime;
                updatedTestData['courseId'] = testData.courseId || courseId;
                updatedTestData['questionsCount'] = testData.questionsCount;
            }
            
            let updatedPhases = JSON.parse(JSON.stringify(state.treeData.phases));
            updatedPhases.forEach((phase, phaseIndex) => {
                if (phase._id === receivedPhaseData._id) {
                    let updatedMilestoneTests = [...updatedPhases[phaseIndex].milestoneTests];
                    const testIndexForUpdate = updatedMilestoneTests.findIndex((test, index) => index === testIndex);
                    if (!isDelete) {
                        // const isTestAlreadyAdded = updatedMilestoneTests.find((test) => test.testId === testData.testId);
                        const {duplicateExists: isTestAlreadyAdded} = checkForDuplicateTests(state.treeData.phases, [testData]);
                        
                        if(testIndex === undefined){
                            if(!isTestAlreadyAdded) {
                                updatedMilestoneTests.push(updatedTestData)
                            }
                        } else {
                            updatedMilestoneTests[testIndexForUpdate] = updatedTestData;
                        }
                    }
                    updatedPhases[phaseIndex].milestoneTests = updatedMilestoneTests;
                }
            });
            state.treeData.phases = updatedPhases;
        },
        deleteMilestoneTest: (state, action) => {
            const { phase: receivedPhaseData, isDelete = false, testIndex } = action.payload;
           let updatedPhases = JSON.parse(JSON.stringify(state.treeData.phases));
            updatedPhases.forEach((phase, phaseIndex) => {
                if (phase._id === receivedPhaseData._id) {
                    let updatedMilestoneTests = [...updatedPhases[phaseIndex].milestoneTests];
                   updatedMilestoneTests = updatedMilestoneTests.filter((test, index) => index !== testIndex);
                   
                    if(isDelete){
                        state.scheduleTestUploadFlag = ''
                    }

                    updatedPhases[phaseIndex].milestoneTests = updatedMilestoneTests;
                }
            });
            state.treeData.phases = updatedPhases;
        },

        deleteScheduleTestFromContent: (state, action) => {
            const { phase: receivedPhaseData, testIndex } = action.payload;
            let updatedPhases = JSON.parse(JSON.stringify(state.treeData.phases));
            let testToDelete;
            if (receivedPhaseData && receivedPhaseData.content && receivedPhaseData.content.length) {
                testToDelete = receivedPhaseData.content[testIndex];
            }
            for (let k = 0; k < updatedPhases.length; k++) {
                if (updatedPhases[k]._id === receivedPhaseData._id) {
                    for (let i = 0; i < updatedPhases[k].weeks.length; i++) {
                        updatedPhases[k].weeks[i].content = updatedPhases[k].weeks[i].content.filter((item) => testToDelete._id !== item._id)
                    }
                }
            }
            state.treeData.phases = updatedPhases;
        },
        
        updateMainTest: (state, action) => {
            const { testData, isDelete = false, courseId, testIndex } = action.payload;
         
            const updatedTestData = JSON.parse(JSON.stringify(testData));

            if(!isDelete) {
                updatedTestData['type'] = testData.paperDetail.type;
                updatedTestData['contentId'] = testData.contentId

                updatedTestData['name'] = testData.paperDetail.name || testData.displayName;
                const copyOfSyllabus = {...testData.paperDetail.syllabus};
                updatedTestData['syllabus'] = copyOfSyllabus.text;
                updatedTestData['testId'] = testData.testId || '000000000000000000000000'; // Changed from testData.paperDetail.id
                
                updatedTestData['scheduleID'] = testData.scheduleID;
                updatedTestData['status'] = testData.status;
                updatedTestData['startDate'] = testData.scheduleDate;
                updatedTestData['endDate'] = testData.scheduleEndDate;
                updatedTestData['maxAttempts'] = testData.maxAttempt;
                updatedTestData['revisionTime'] = testData.blockRevisionTime;
                updatedTestData['courseId'] = courseId;
                updatedTestData['questionsCount'] = testData.questionsCount;
                
            }
            
            let updatedPhases = JSON.parse(JSON.stringify(state.treeData.phases));
            const phasesLength = updatedPhases.length;
            updatedPhases.forEach((phase, phaseIndex) => {
                let isTestUpdatedInAnyWeek = false;
                let nextPhaseStartDate;
                if(phaseIndex !== phasesLength - 1) {
                    nextPhaseStartDate = updatedPhases[phaseIndex + 1] && new Date(updatedPhases[phaseIndex + 1].startDate)
                } else {
                    nextPhaseStartDate = null;
                }
                const phaseStartDate = new Date(phase.startDate);
                const phaseEndDate = new Date(phase.endDate);
                const testStartDate = new Date(updatedTestData.startDate);
                const testEndDate = new Date(updatedTestData.endDate);

                const isTestInThisPhase = checkIfTestInThisPhase(
                    testStartDate,
                    testEndDate,
                    phaseStartDate,
                    phaseEndDate,
                    nextPhaseStartDate
                );


                let updatedWeeks = JSON.parse(JSON.stringify(phase.weeks));
                updatedWeeks.forEach((week, weekIndex) => {
                    let updatedContent = JSON.parse(JSON.stringify(week.content));
                    let isTestInThisWeek = false;
                    const weekStartDate = new Date(week.startDate);
                    const weekEndDate = new Date(week.endDate);
                    weekStartDate.setHours(0, 0, 0);
                    weekEndDate.setHours(23, 59, 59);
 
                    isTestInThisWeek = checkIfMainTestInThisWeek(
                        testStartDate,
                        testEndDate,
                        weekStartDate,
                        weekEndDate
                    );
                    

                    if (isTestInThisWeek) {
                        const testIndexToUpdate = updatedContent.findIndex((test, index) => {
                            if(testIndex !== undefined){
                                return testIndex === index
                            }
                            return test.testId === testData.testId
                        
                        });
                        
                        if (testIndexToUpdate === -1) {
                            return testIndexToUpdate
                        }
                        if (!isDelete) {
                            updatedContent[testIndexToUpdate] = updatedTestData;
                        }

                        updatedWeeks[weekIndex].content = updatedContent;
                        isTestUpdatedInAnyWeek = true;
                    }
                });
                
                if(!isTestUpdatedInAnyWeek){
                    if(isTestInThisPhase){
                        let updatedExtraTests = [...phase.extraTests]
                        const testIndexToUpdate = updatedExtraTests.findIndex((test, index) => {
                            if(testIndex !== undefined){
                                return testIndex === index
                            }
                            return test.testId === testData.testId
                        });
                        if (!isDelete) {
                            updatedExtraTests[testIndexToUpdate] = updatedTestData;
                            updatedPhases[phaseIndex].extraTests = updatedExtraTests;
                        }
                    }
                }

                updatedPhases[phaseIndex].weeks = updatedWeeks;
            });
            state.treeData.phases = updatedPhases;
            
        },
        deleteMaintest: (state, action) => {
            const { testData, isDelete = false, testIndex } = action.payload;
            
            const updatedTestData = JSON.parse(JSON.stringify(testData));


            let updatedPhases = JSON.parse(JSON.stringify(state.treeData.phases));
            const phasesLength = updatedPhases.length;
            updatedPhases.forEach((phase, phaseIndex) => {

                let isTestUpdatedInAnyWeek = false;
                let nextPhaseStartDate;
                if(phaseIndex !== phasesLength - 1) {
                    nextPhaseStartDate = updatedPhases[phaseIndex + 1] && new Date(updatedPhases[phaseIndex + 1].startDate)
                } else {
                    nextPhaseStartDate = null;
                }
                const phaseStartDate = new Date(phase.startDate);
                const phaseEndDate = new Date(phase.endDate);
                const testStartDate = new Date(updatedTestData.startDate);
                const testEndDate = new Date(updatedTestData.endDate);

                const isTestInThisPhase = checkIfTestInThisPhase(
                    testStartDate,
                    testEndDate,
                    phaseStartDate,
                    phaseEndDate,
                    nextPhaseStartDate
                );

                let updatedWeeks = JSON.parse(JSON.stringify(phase.weeks));
                updatedWeeks.forEach((week, weekIndex) => {
                    let updatedContent = JSON.parse(JSON.stringify(week.content));
                    let isTestInThisWeek = false;

                    const weekStartDate = new Date(week.startDate);
                    const weekEndDate = new Date(week.endDate);
                    weekStartDate.setHours(0, 0, 0);
                    weekEndDate.setHours(23, 59, 59);
                    
                    isTestInThisWeek = checkIfMainTestInThisWeek(
                        testStartDate,
                        testEndDate,
                        weekStartDate,
                        weekEndDate
                    );


                    if (isTestInThisWeek) {
                        updatedContent = updatedContent.filter((test, index) => {
                            if(testIndex !== undefined){
                                return testIndex !== index
                            }
                            return test.testId !== testData.testId
                        
                        });
                        
                        if (updatedContent.length === 0) {
                            return updatedContent
                        }
                      
                        if(isDelete){
                            state.scheduleTestUploadFlag = ''
                        }

                        updatedWeeks[weekIndex].content = updatedContent;
                        isTestUpdatedInAnyWeek = true;
                        
                    }
                });

                if(!isTestUpdatedInAnyWeek){
                    
                    if(isTestInThisPhase){
                        let updatedExtraTests = [...phase.extraTests]
                        updatedExtraTests = updatedExtraTests.filter((test, index) => {
                            if(testIndex !== undefined){
                                return testIndex !== index
                            }
                            return test.testId !== testData.testId
                        });
                        updatedPhases[phaseIndex].extraTests = updatedExtraTests;
                    }
                    
                }

                updatedPhases[phaseIndex].weeks = updatedWeeks;
            });
            state.treeData.phases = updatedPhases;
        },
        setPackageData: (state, action) => {
            state.packageData = action.payload;
        },
        setMergedComboCourse: (state = {}, action = {}) => {

            const { payload = {} } = action;
            return {
                ...state, mergedComboCourse: JSON.parse(JSON.stringify(payload))
            };
        },
        setIsCoursePublished: (state, action) => {
            state.isCoursePublished = true;
        },
        setActiveTabForCoursePlanLandingPage: (state = {}, action = {}) => {
            const { payload: { activeTabForCoursePlanLandingPage = 0 } = {} } = action;
            return { ...state, activeTabForCoursePlanLandingPage };
        },
        setSelectedGoalsForTestSeries: (state = {}, action = {}) => {
            const { payload: { selectedGoalsForTestSeries = [] } = {} } = action;
            return { ...state, selectedGoalsForTestSeries };
        },
        setIsTabOpen: (state = {}, action = {}) => {
            const { payload: { booleanValue = false } = {} } = action;
            return { ...state, isTabOpen: booleanValue };
        },
        setIsCoursPlanTabAbleToPublish: (state = {}, action = {}) => {
            const { payload: { booleanValue = false } } = action;
            return { ...state, isCoursPlanTabAbleToPublish: booleanValue };
        },
        resetAllState: (state = {}, action ={} ) => {
            return { ...state, ...initialState }
        },
        setCoursePackageList: (state = {}, action ={} ) => {
            const coursePackageList = action.payload
            state.coursePackageList = coursePackageList
        },
        setPreferenceData: (state = {}, action ={} ) =>{
            
            const { packageByIdData:{packageData = {}} = {} } = state;
            const {payload = {}}  = action;
            packageData.contentPreferences = payload;
           
            // const {packageByIdData = {}} = state;
            state.packageByIdData.packageData = packageData;
        },
        moveData: (state = {}, action = {}) => {
            const { payload } = action;
            state.treeData = payload;
        },
        resetBulkDrag: (state = {}, action = {}) => {
            state.bulkDrag = {}
        },
        setGoalsDriller:(state={},action={})=>{
            state.goalsDriller=action.payload;
        },
        setRevisedHours: (state={}, action={}) => {
            state.revisedHours = action.payload;
        },
        setPhaseUploadFileUrl: (state = {}, action = {}) => {
            state.phaseUploadUrl = {...state.phaseUploadUrl, ...action.payload};
        },
        setActiveCoursePlanView: (state = {}, action = {}) => {
            state.activeCoursePlanViewList = action.payload;
        }
    }

});
const { actions, reducer } = contentManagementSlice;
const contentManagementAction = actions;
export { contentManagementAction };
export default reducer;
